import services from 'services/module';
import SpinnerSvc from 'services/SpinnerSvc';
import {TagsSvc} from './TagsSvc';
import {HttpSvcFactory} from './HttpSvc';
import {BackendSvc} from './BackendSvc';
import {Utils} from '../underscore-extensions';
import {PROJECT_ADD} from './AnimatronProjectsSvc';
import {TranslateSvc} from './TranslateSvc';

export type AdminSvcFactory = new(project: anm.Project) => AdminSvc;

export class AdminSvc {
    private $http: ng.IHttpService;
    private TagsSvc: TagsSvc;
    private HttpSvc: HttpSvcFactory;
    private BackendSvc: BackendSvc;
    private $rootScope: ng.IRootScopeService;
    private TranslateSvc: TranslateSvc;

    exportActions = ['json', 'anm', 'zip', 'svg', 'png'];
    roles         = options.user.subscriptionDetails.studio.features.rolez;
    staffPickTag  = {name: 'Staff Picks', type: 'SUPER' as 'SUPER'};
    duplicating   = false;


    constructor(private project: anm.Project) {
    }

    staffLike() {
        SpinnerSvc.show();
        this.project.staffPicked = true;
        this.TagsSvc.saveTag(this.staffPickTag, this.project.id)
            .then(() => this.project.tags.push(this.staffPickTag))
            .catch(this.errorFunction.bind(this)).finally(() => SpinnerSvc.hide());
    };

    staffDislike() {
        SpinnerSvc.show();
        this.project.staffPicked = false;
        this.TagsSvc.tagRemoved(this.staffPickTag, this.project.id).then(() => {
                this.project.tags = this.project.tags.filter(tag => tag.name !== this.staffPickTag.name);
            }
        ).finally(() => SpinnerSvc.hide());
    };

    exportProject = (action: string) =>
        this.BackendSvc.getServerUrl(this.project).then(url => {
            const exportUrl = `${url}/project/export/${action}/${this.project.id}?params={}&t=0`;
            window.open(exportUrl, '_self');
        });

    doctor = (action: string) =>
        this.BackendSvc.getServerUrl(this.project).then(url => {
            const doctorUrl = `${url}/doctor/show/${this.project.id}`;
            window.open(doctorUrl, '_blank');
        });

    duplicateProject(errMsg: string) {
        SpinnerSvc.show();
        this.duplicating = true;
        const url        = `project-api?oldProjectId=${this.project.id}&product=${this.project.product}`;
        const opts       = {headers: _.extend({'Content-Type': 'text/plain'}, options.headers)};

        return this.HttpSvc(url)
            .post({}, opts)
            .then(r => r.data)
            .then((projectServerMapping: {url: string}) => {
                const newName            = this.project.name + 'Copy_from_website',
                      path               = '/project/duplicate',
                      params             = '?name=' + newName + '&oldId=' + this.project.id,
                      duplicateUrl       = projectServerMapping.url.replace('http:', 'https:') + path + params,
                      duplicateProjectId = projectServerMapping['project-id'];

                opts.headers['Animatron-Project-ID'] = duplicateProjectId;


                return this.$http
                    .post(duplicateUrl, '', opts)
                    .then(() => this.HttpSvc('project', duplicateProjectId).secureGet())
                    .then(r => r.data)
                    .then((project: anm.Project) => {
                        if (!Utils.isApiError(project)) {
                            this.$rootScope.$emit(PROJECT_ADD, {project});
                        }
                    })
                    .then(() => _.notification.showSuccess(this.TranslateSvc.get('wave.video.copy.alert', errMsg)));
            })
            .finally(() => {
                this.duplicating = false;
                SpinnerSvc.hide();
            });
    };

    private errorFunction(error: string) {
        console.log(error);
        _.notification.showError('Failed to modify staff picks');
    };
}

function AdminSvcFactory($http: ng.IHttpService,
                         $rootScope: ng.IRootScopeService,
                         TagsSvc: TagsSvc,
                         HttpSvc: HttpSvcFactory,
                         BackendSvc: BackendSvc,
                         TranslateSvc: TranslateSvc) {
    _.extend(AdminSvc.prototype, {
        $http, TagsSvc, HttpSvc, BackendSvc, $rootScope, TranslateSvc
    });
    return AdminSvc;
}
services.service('AdminSvc', AdminSvcFactory);



// WEBPACK FOOTER //
// ./app/assets/javascripts/services/AdminSvc.ts